import { Component } from '@angular/core';

@Component({
    selector: 'stby-error',
    styleUrl: './error.scss',
    templateUrl: './error.html',
})
export class Error {}
